import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function LegalSection({ id, n, title, children }) {
  return (
    <section id={id} className="scroll-mt-28 mb-12">
      <h2 className="m61-h3 mb-4 text-m61-text">
        <span className="text-m61-cyan font-mono mr-2">{n}.</span>{title}
      </h2>
      <div className="space-y-4 text-m61-muted leading-relaxed">{children}</div>
    </section>
  );
}

export default function LegalPage({ eyebrow, title, accent, effective, updated, toc, children }) {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 120);
    }
  }, [location.hash]);

  return (
    <div>
      <section className="m61-grid-bg border-b border-m61-line">
        <div className="m61-container py-16 lg:py-20">
          {eyebrow && <p className="m61-eyebrow mb-6">{eyebrow}</p>}
          <h1 className="m61-h1 mb-6">
            {title} {accent && <span className="m61-gradient-text">{accent}</span>}
          </h1>
          <p className="font-mono text-xs text-m61-muted uppercase tracking-wider">
            Effective: {effective} · Last updated: {updated}
          </p>
        </div>
      </section>

      <section className="m61-section">
        <div className="m61-container grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Sticky contents */}
          <aside className="lg:col-span-4 xl:col-span-3">
            <div className="lg:sticky lg:top-28">
              <p className="m61-label mb-4">Contents</p>
              <nav className="space-y-2">
                {toc.map((t, i) => (
                  <a key={t.id} href={`#${t.id}`} className="block text-sm text-m61-muted hover:text-m61-cyan transition-colors">
                    <span className="font-mono text-m61-muted/60 mr-2">{String(i + 1).padStart(2, "0")}</span>{t.title}
                  </a>
                ))}
              </nav>
            </div>
          </aside>

          {/* Body */}
          <div className="lg:col-span-8 xl:col-span-9 max-w-3xl">{children}</div>
        </div>
      </section>
    </div>
  );
}
